export default __webpack_public_path__ + "static/media/Palavecino.cca355cd.jpg";